import React from 'react'
import ServiceResultCardComponent from '../../../Components/card/serviceResultCard'

const DatalistSection = ({ servicesData = [] }) => {
    return (
        <div className="flex flex-col gap-4"> {/* Use flex column layout for vertical arrangement */}
            {servicesData.length > 0 ? (
                servicesData.map((serviceData, index) => (
                    <ServiceResultCardComponent key={index} serviceData={serviceData} />
                ))
            ) : (
                <p>No services available.</p> // Placeholder text when no data is available
            )}
        </div>
    )
}

export default DatalistSection
